'use strict';

/* jshint node: true, esnext: true, loopfunc: true, undef: true, unused: true */

var checkType = require('./type');
var getType = checkType.getType;
var isFunction = checkType.isFunction;
var isObject = checkType.isObject;
var isPlainObject = checkType.isPlainObject;

var arrayUtils = require('./array');
var contains = arrayUtils.contains;
var each = arrayUtils.each;
var isArrayLike = arrayUtils.isArrayLike;
var toArray = arrayUtils.toArray;

function toPlainObject(obj) {
    return isPlainObject(obj) ? obj : {};
}
function forIn(obj, callback, thisObj) {
    var plainObj = toPlainObject(obj);
    for (var key in plainObj) {
        callback.call(thisObj, plainObj[key], key, obj);
    }
}

var keys = Object.keys ? function (obj) {
    return Object.keys(obj);
} : function (obj) {
    var result = [];
    forIn(obj, function (value, key) {
        if (!(isFunction(obj) && key === 'prototype')) {
            result.push(key);
        }
    });
    return result;
};

function values(obj) {
    var result = [];
    forIn(obj, function (value) {
        return result.push(value);
    });
    return result;
}

function extend(dest) {
    dest = dest || {};
    each(toArray(arguments).slice(1), function (source) {
        if (source) {
            for (var prop in source) {
                dest[prop] = source[prop];
            }
        }
    });
    return dest;
}

function merge(dest) {
    dest = dest || {};
    each(toArray(arguments).slice(1), function (source) {
        for (var prop in source) {
            if (getType(source[prop]) !== getType(dest[prop])) {
                if (isPlainObject(source[prop])) {
                    dest[prop] = {};
                    merge(dest[prop], source[prop]);
                } else {
                    dest[prop] = source[prop];
                }
            } else {
                if (isPlainObject(source[prop])) {
                    merge(dest[prop], source[prop]);
                } else {
                    dest[prop] = source[prop];
                }
            }
        }
    });
    return dest;
}

var objectUtils = {
    assign: extend,
    forIn: forIn,
    extend: extend,
    hasKey: function hasKey(obj, key) {
        return obj.hasOwnProperty(key);
    },
    hasValue: function hasValue(obj, value) {
        return contains(values(obj), value);
    },
    isObject: isObject,
    isPlainObject: isPlainObject,
    keys: keys,
    merge: merge,
    values: values,
    invert: function invert(obj) {
        var result = {};
        forIn(obj, function (value, key) {
            result[value] = key;
        });
        return result;
    },
    clone: function clone(obj) {
        if (isArrayLike(obj)) {
            return toArray(obj);
        }
        if (isPlainObject(obj)) {
            return merge({}, obj);
        }
        return obj;
    },
    destroy: function destroy(obj) {
        for (var p in obj) {
            delete obj[p];
        }
        obj.prototype = null;
        obj = null;
    }
};

module.exports = objectUtils;


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-lang/object.js
 ** module id = 29
 ** module chunks = 0
 **/